<template>
    <div class="h-screen flex w-full bg-img vx-row items-center justify-center" id="page-login">
        <div class="vx-col">
            <vx-card>
                <div slot="no-body" class="full-page-bg-color">
                    <div class="vx-col d-theme-dark-bg">
                        <div class="p-8 login-tabs-container">

                            <div class="vx-card__title mb-4">
                                <center class="mb-4">
                                    <img src="logo.png" alt="logo" width="81px" height="81px">
                                </center>
                                <p>Connectez-vous pour commencer une session</p>
                            </div>

                            <div>
                               <div>
                                  <vs-input
                                    :danger="errors.email ? true : false"
                                    :danger-text="errors.email ? errors.email[0] : ''"
                                    autocomplete="off"
                                    name="email"
                                    icon-no-border
                                    icon="icon icon-user"
                                    icon-pack="feather"
                                    label-placeholder="Adresse email"
                                    v-model="form.email"
                                    class="w-full"/>
                               </div>

                                <div class="i-toggle">
                                  <vs-input
                                    :danger="errors.password ? true : false"
                                    :danger-text="errors.password ? errors.password[0] : ''"
                                    autocomplete="off"
                                    :type="eye ? 'text' : 'password'"
                                    name="password"
                                    icon-no-border
                                    icon="icon icon-lock"
                                    icon-pack="feather"
                                    label-placeholder="Mot de passe"
                                    v-model="form.password"
                                    class="w-full mt-6" />
                                    <div class="mt-6 toggle-icon">
                                      <feather-icon @click="() => eye = !eye" style="cursor:pointer"
                                      svgClasses="w-5 h-5 hover:text-primary stroke-current"
                                        :icon="eye ? 'EyeIcon' : 'EyeOffIcon'"
                                      />
                                    </div>
                                </div>

                                <div class="flex flex-wrap justify-between my-5">
                                    <!--<router-link to="">Mot de passe oublié ?</router-link>-->
                                </div>
                                <!-- <vs-button @click="login" class="float-right">Connexion</vs-button> -->
                                <vs-button @click="login()" class="float-right">Connexion</vs-button>
                                <br>
                            </div>

                        </div>
                    </div>
                </div>
            </vx-card>
        </div>
    </div>
</template>

<script>
    import auth from "../../helper/auth";
    export default{
        data() {
            return {
                form:{
                    email: "",
                    password: "",
                },
                errors: [],
                eye: false
            }
        },
        methods:{
            login(){
                this.$vs.loading()
                this.$http.post('auth/login', this.form).then((response) =>{
                    if (response.data.status){
                        auth.authenticate(response.data)
                        this.errors = []
                        if (response.data.user.profile == '1'){
                          this.$router.push({name: 'payments'})
                        }else this.$router.push('/')
                        this.$vs.loading.close()
                    }
                }).catch((error) => {
                    this.$vs.loading.close()
                    this.errors = error.response.data.errors
                })
            }
        }
    }
</script>

<style lang="scss">
    #page-login {
        .social-login-buttons {
            .bg-facebook { background-color: #1551b1 }
            .bg-twitter { background-color: #00aaff }
            .bg-google { background-color: #4285F4 }
            .bg-github { background-color: #333 }
        }
    }
    .i-toggle{
      display: flex;
      flex-direction: row;
    }
    .toggle-icon{
      margin-left: -23px;
      padding-top: 9px;
    }
</style>
